<template>
  <div>
    <page-loading v-if="loading" message="Carregando indicadores" />
    <template v-else>
      <v-row dense>
        <v-col cols="12" sm="6" md="3">
          <partner-summary-metric-card title="Vendas hoje" :value="formatPrice(data.salesToday)" icon="mdi-cash" variant="finance" />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <partner-summary-metric-card title="Vendas no mês" :value="formatPrice(data.salesThisMonth)" icon="mdi-chart-line" variant="brand" />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <partner-summary-metric-card title="Ticket médio" :value="formatPrice(data.averageTicket)" icon="mdi-receipt" variant="network" />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <partner-summary-metric-card title="Cashback gerado" :value="formatPrice(data.cashbackGenerated)" icon="mdi-gift" variant="amber" />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageLoading from "@/components/loading/PageLoading.vue";
import PartnerSummaryMetricCard from "@/components/summary/PartnerSummaryMetricCard.vue";
import { pdvApi } from "@/services/pdv/pdvApi";

export default defineComponent({
  components: { PageLoading, PartnerSummaryMetricCard },
  data() {
    return {
      loading: true,
      data: { salesToday: 0, salesThisMonth: 0, averageTicket: 0, cashbackGenerated: 0 },
    };
  },
  async mounted() {
    this.data = await pdvApi.getDashboard();
    this.loading = false;
  },
  methods: {
    formatPrice(v: number) {
      return Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
  },
});
</script>
